export default function Footer() {
    return (
      <footer className="bg-amber-200 py-6 mt-24">
        <div className="container mx-auto px-6 text-center">
          <p>&copy; All rights reserved.</p>
        </div>
      </footer>
    )
  }
  